export default function renderChildrenWithProps(children, props) {
    if (typeof children === 'function')
        return children(props);
    return children;
}
